import { v4 as uuid } from 'uuid';

import { categoriesSelectors } from 'app-components/flux/categories';
import { categoriesTypes } from 'app-components/flux/categories';
import { taxLineItemsSelectors } from 'app-components/flux/tax-line-items';
import store from 'app-components/utils/redux-store';

const missingTaxLineItemsCategories = () => {
  let resources;
  if (store) {
    const categories = categoriesSelectors.getResourcesById(store.getState());
    const taxLineItems = taxLineItemsSelectors.getResourcesById(store.getState());
    const parentClientId = uuid().toUpperCase();
    resources = taxLineItems.reduce(
      (missingTaxLineItems: ReturnType<typeof categoriesTypes.mkCategory>[], taxLineItem) => {
        const category = categories.find((category) => category.txfId === taxLineItem.id);
        if (!category) {
          missingTaxLineItems.push(
            categoriesTypes.mkCategory({
              clientId: uuid().toUpperCase(),
              categoryType: 'EXPENSE',
              parentClientId,
              name: `${taxLineItem.txfId} - ${taxLineItem.name}`,
              txfId: taxLineItem.id,
            }),
          );
        }
        return missingTaxLineItems;
      },
      [],
    );
    if (resources.length) {
      resources.push(
        categoriesTypes.mkCategory({
          clientId: parentClientId,
          categoryType: 'EXPENSE',
          name: 'Missing Tax Line Items',
        }),
      );
    }
  }
  return { resources };
};

export default missingTaxLineItemsCategories;
